import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
import { Map } from './common/Map';

export function Contact() {
  return (
    <section className="py-16 px-12 bg-accessible-gray-50 dark:bg-accessible-gray-800 high-contrast:bg-black">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="section-title">
            Skontaktuj się z nami
          </h2>
          <p className="body-large max-w-2xl mx-auto">
            Jesteśmy tutaj, aby odpowiedzieć na Twoje pytania i pomóc naszym podopiecznym
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          <a 
            href="tel:+48664821160"
            className="group bg-white dark:bg-accessible-gray-700 high-contrast:bg-black p-8 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 hover:bg-accessible-gray-50 dark:hover:bg-accessible-gray-600 high-contrast:hover:bg-white/10"
            aria-label="Zadzwoń do nas: 664 821 160"
          >
            <div className="flex flex-col items-center text-center">
              <Phone className="w-12 h-12 text-accessible-red-600 mb-4 group-hover:scale-110 transition-transform group-hover:text-accessible-red-700" aria-hidden="true" />
              <h3 className="card-title tight-spacing">
                Telefon
              </h3>
              <p className="body-medium text-accessible-gray-600 dark:text-accessible-gray-300 high-contrast:text-white no-margin">
                664 821 160
              </p>
            </div>
          </a>

          <a 
            href="mailto:znajdki2012@gmail.com"
            className="group bg-white dark:bg-accessible-gray-700 high-contrast:bg-black p-8 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 hover:bg-accessible-gray-50 dark:hover:bg-accessible-gray-600 high-contrast:hover:bg-white/10"
            aria-label="Napisz do nas: znajdki2012@gmail.com"
          >
            <div className="flex flex-col items-center text-center">
              <Mail className="w-12 h-12 text-accessible-red-600 mb-4 group-hover:scale-110 transition-transform group-hover:text-accessible-red-700" aria-hidden="true" />
              <h3 className="card-title tight-spacing">
                Email
              </h3>
              <p className="body-medium text-accessible-gray-600 dark:text-accessible-gray-300 high-contrast:text-white no-margin">
                znajdki2012@gmail.com
              </p>
            </div>
          </a>

          <a 
            href="https://maps.google.com/?q=Krusze+ul.+Kryształowa+171,+05-240+Tłuszcz"
            target="_blank"
            rel="noopener noreferrer"
            className="group bg-white dark:bg-accessible-gray-700 high-contrast:bg-black p-8 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 hover:bg-accessible-gray-50 dark:hover:bg-accessible-gray-600 high-contrast:hover:bg-white/10"
            title="Zobacz naszą lokalizację na mapie"
          >
            <div className="flex flex-col items-center text-center">
              <MapPin className="w-12 h-12 text-accessible-red-600 mb-4 group-hover:scale-110 transition-transform group-hover:text-accessible-red-700" />
              <h3 className="card-title tight-spacing">
                Adres
              </h3>
              <p className="body-medium text-accessible-gray-600 dark:text-accessible-gray-300 high-contrast:text-white no-margin">
                <span className="block">Fundacja Znajdki</span>
                <span className="block">Krusze ul. Kryształowa 171</span>
                <span className="block">05-240 Tłuszcz</span>
              </p>
            </div>
          </a>
        </div>

        <Map
          className="bg-white dark:bg-accessible-gray-700 high-contrast:bg-black"
          satellite
          query="Krusze ul. Kryształowa 171, 05-240 Tłuszcz"
          zoom={17}
        />
      </div>
    </section>
  );
}